import { isValidVin } from '@greasemap/core';
import { z } from 'zod';

/** A client-generated UUID. */
export const uuidSchema = z.uuid();

/** An ISO-8601 timestamp. */
export const isoDateTimeSchema = z.iso.datetime({ offset: true });

/**
 * A vehicle identification number.
 *
 * VINs issued from the 1981 model year onward are exactly 17 characters and never contain I, O or
 * Q, which exist only to be confused with 1 and 0. Rejecting them here gives a better message than
 * a failed vPIC lookup would.
 */
export const vinSchema = z
  .string()
  .trim()
  .toUpperCase()
  .length(17, 'A VIN is 17 characters.')
  .regex(/^[A-HJ-NPR-Z0-9]+$/, 'A VIN cannot contain the letters I, O or Q.')
  // The check digit is what actually catches a typo, and it is why the server would otherwise
  // reject a VIN the browser had already accepted.
  .refine(isValidVin, 'That VIN does not pass its check digit, so it contains a typo.');
